import { render, staticRenderFns } from "./segments.vue?vue&type=template&id=6c01beb6&scoped=true"
import script from "./segments.vue?vue&type=script&lang=js"
export * from "./segments.vue?vue&type=script&lang=js"
import style0 from "./segments.vue?vue&type=style&index=0&id=6c01beb6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c01beb6",
  null
  
)

export default component.exports